// Use event delegation and lowercase attribute names to match HTML
$(document).on('click', 'div[popoverbutton]', function (e) {
    e.stopPropagation();
    var id = $(this).attr('popoverbutton');
    if ($('.popup--content[popovercontent="' + id + '"]').is(':visible')) {
        $('.popup--content[popovercontent="' + id + '"]').slideUp();
        $(this).removeClass('active');
    } else {
        $('.popup--content[popovercontent="' + id + '"]').slideDown();
        $('.popup--content:not([popovercontent="' + id + '"])').slideUp();
        $(this).addClass('active');
    }
});

// Close popover when clicking outside - only bind once
$(document).on('click', function (e) {
    var container = $('.popup--content');
    var button = $('div[popoverbutton]');
    if (!container.is(e.target) && container.has(e.target).length === 0 &&
        !button.is(e.target) && button.has(e.target).length === 0) {
        $('.popup--content').slideUp();
        $('div[popoverbutton]').removeClass('active');
    }
});

// copy current url to clipboard (blog single)
function copyLink() {
    var copyText = window.location.href;
    navigator.clipboard.writeText(copyText);
}
$('.copy--link').click(function (e) {
    e.preventDefault();
    copyLink();
    return false;
});
